import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar,
    ) { }   

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    // Récupérer le rôle requis depuis la configuration de la route
    const requiredRole = route.data['role'];

    // Vérifier si l'utilisateur est connecté
    if (!(this.authService.getLoggedUser()).status) {
      return this.router.parseUrl('/login'); // Rediriger vers la page de connexion
    }

    // Récupérer le rôle de l'utilisateur

    const storageAuth = localStorage.getItem("user");
    let User = JSON.parse(storageAuth!);
    if(User.roleApp){
      return true;
    }
    else{
        this.snackBar.open("Veillez choisir votre type de compte afin de pouvoir vous connecter", "Fermer", {
            duration: 6000,
            verticalPosition: 'top',
            panelClass: ['snackbar-danger']
        });
        return this.router.parseUrl('/switch');
    }
    
  }
}